module.exports = __webpack_public_path__ + "img/Weapon_266.0d5796e0.png";